// extracted by mini-css-extract-plugin
module.exports =  {"minimumEnvText":"style-module_minimumEnvText__H6GcxtF2dDv_FetqWDIh","minCompleteLabel":"style-module_minCompleteLabel__bubvjAZQEWdqiQ0hsliW"};